/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SearchRequest,
  SolrResultSolrOrganisationReduced,
  SolrResultSolrPersonReduced,
  SolrResultSolrProjectReduced,
  SolrResultSolrPublisher,
  SolrResultSolrWorkReduced,
} from '../models/index';
import {
    SearchRequestFromJSON,
    SearchRequestToJSON,
    SolrResultSolrOrganisationReducedFromJSON,
    SolrResultSolrOrganisationReducedToJSON,
    SolrResultSolrPersonReducedFromJSON,
    SolrResultSolrPersonReducedToJSON,
    SolrResultSolrProjectReducedFromJSON,
    SolrResultSolrProjectReducedToJSON,
    SolrResultSolrPublisherFromJSON,
    SolrResultSolrPublisherToJSON,
    SolrResultSolrWorkReducedFromJSON,
    SolrResultSolrWorkReducedToJSON,
} from '../models/index';

export interface SearchOrganisationRequest {
    searchRequest: SearchRequest;
}

export interface SearchPersonRequest {
    searchRequest: SearchRequest;
}

export interface SearchProjectRequest {
    searchRequest: SearchRequest;
}

export interface SearchPublisherRequest {
    searchRequest: SearchRequest;
}

export interface SearchWorkRequest {
    searchRequest: SearchRequest;
}

/**
 * 
 */
export class SearchApi extends runtime.BaseAPI {

    /**
     * Creates request options for searchOrganisation without sending the request
     */
    async searchOrganisationRequestOpts(requestParameters: SearchOrganisationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['searchRequest'] == null) {
            throw new runtime.RequiredError(
                'searchRequest',
                'Required parameter "searchRequest" was null or undefined when calling searchOrganisation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/search/organisation`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchRequestToJSON(requestParameters['searchRequest']),
        };
    }

    /**
     */
    async searchOrganisationRaw(requestParameters: SearchOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SolrResultSolrOrganisationReduced>> {
        const requestOptions = await this.searchOrganisationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SolrResultSolrOrganisationReducedFromJSON(jsonValue));
    }

    /**
     */
    async searchOrganisation(requestParameters: SearchOrganisationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SolrResultSolrOrganisationReduced> {
        const response = await this.searchOrganisationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchPerson without sending the request
     */
    async searchPersonRequestOpts(requestParameters: SearchPersonRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['searchRequest'] == null) {
            throw new runtime.RequiredError(
                'searchRequest',
                'Required parameter "searchRequest" was null or undefined when calling searchPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/search/person`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchRequestToJSON(requestParameters['searchRequest']),
        };
    }

    /**
     */
    async searchPersonRaw(requestParameters: SearchPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SolrResultSolrPersonReduced>> {
        const requestOptions = await this.searchPersonRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SolrResultSolrPersonReducedFromJSON(jsonValue));
    }

    /**
     */
    async searchPerson(requestParameters: SearchPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SolrResultSolrPersonReduced> {
        const response = await this.searchPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchProject without sending the request
     */
    async searchProjectRequestOpts(requestParameters: SearchProjectRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['searchRequest'] == null) {
            throw new runtime.RequiredError(
                'searchRequest',
                'Required parameter "searchRequest" was null or undefined when calling searchProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/search/project`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchRequestToJSON(requestParameters['searchRequest']),
        };
    }

    /**
     */
    async searchProjectRaw(requestParameters: SearchProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SolrResultSolrProjectReduced>> {
        const requestOptions = await this.searchProjectRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SolrResultSolrProjectReducedFromJSON(jsonValue));
    }

    /**
     */
    async searchProject(requestParameters: SearchProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SolrResultSolrProjectReduced> {
        const response = await this.searchProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchPublisher without sending the request
     */
    async searchPublisherRequestOpts(requestParameters: SearchPublisherRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['searchRequest'] == null) {
            throw new runtime.RequiredError(
                'searchRequest',
                'Required parameter "searchRequest" was null or undefined when calling searchPublisher().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/search/publisher`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchRequestToJSON(requestParameters['searchRequest']),
        };
    }

    /**
     */
    async searchPublisherRaw(requestParameters: SearchPublisherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SolrResultSolrPublisher>> {
        const requestOptions = await this.searchPublisherRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SolrResultSolrPublisherFromJSON(jsonValue));
    }

    /**
     */
    async searchPublisher(requestParameters: SearchPublisherRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SolrResultSolrPublisher> {
        const response = await this.searchPublisherRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchWork without sending the request
     */
    async searchWorkRequestOpts(requestParameters: SearchWorkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['searchRequest'] == null) {
            throw new runtime.RequiredError(
                'searchRequest',
                'Required parameter "searchRequest" was null or undefined when calling searchWork().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/search/work`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchRequestToJSON(requestParameters['searchRequest']),
        };
    }

    /**
     */
    async searchWorkRaw(requestParameters: SearchWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SolrResultSolrWorkReduced>> {
        const requestOptions = await this.searchWorkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SolrResultSolrWorkReducedFromJSON(jsonValue));
    }

    /**
     */
    async searchWork(requestParameters: SearchWorkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SolrResultSolrWorkReduced> {
        const response = await this.searchWorkRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
